/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Edit_Logistics_Details_DescriptionInputs */

const en_orders_edit_logistics_details_description = /** @type {(inputs: Orders_Edit_Logistics_Details_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update driver and tracking information.`)
};

const es_orders_edit_logistics_details_description = /** @type {(inputs: Orders_Edit_Logistics_Details_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiza informacion del chofer y tracking.`)
};

/**
* | output |
* | --- |
* | "Update driver and tracking information." |
*
* @param {Orders_Edit_Logistics_Details_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_edit_logistics_details_description = /** @type {((inputs?: Orders_Edit_Logistics_Details_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Edit_Logistics_Details_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_edit_logistics_details_description(inputs)
	return es_orders_edit_logistics_details_description(inputs)
});